import { apiService as Service } from '@/services/service'

export const userService = {
	login: ({ username, password }: Api.LoginInputInput) => {
		return Service.post<Api.OauthResponse>({
			url: 'oauth/token',
			data: {
				username: username,
				password: password,
				grant_type: 'password',
				scope: null,
				client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
				client_secret: import.meta.env.VITE_OAUTH_SECRET,
			},
		})
	},
	lostPassword(email: string) {
		const url = `api/${import.meta.env.VITE_API_VERSION}/notifications/lostpassword`
		return Service.post({
			url,
			data: { email },
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		})
	},
	changePassword({
		old_password,
		new_password,
		new_password_confirmation,
	}: Api.ChangePasswordInput) {
		return Service.post<Omit<Api.ChangePasswordInput, 'email'>>({
			url: 'changepassword',
			data: {
				old_password,
				new_password,
				new_password_confirmation,
			},
		})
	},
	verifyPassword(password: string) {
		return Service.post<{ result: boolean; message?: string }>({
			url: 'verifypassword',
			data: {
				password,
			},
		})
	},
	refresh: ({ refresh_token }: { refresh_token: string }) => {
		return Service.post<Api.OauthResponse>({
			url: 'oauth/token',
			data: {
				grant_type: 'refresh_token',
				refresh_token,
				scope: null,
				client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
				client_secret: import.meta.env.VITE_OAUTH_SECRET,
			},
		})
	},
	resetPassword({
		email,
		password,
		password_confirmation,
		token,
	}: Api.ResetPasswordInput) {
		return Service.post({
			url: 'password/reset',
			data: {
				email,
				password,
				password_confirmation,
				token,
			},
		})
	},
	persons: ({ relations }: { relations: string }) =>
		Service.get<Api.Collection<Api.Person>>({
			url: `profile/persons?rel=${relations}`,
		}),
	permissions: () =>
		Service.get<Api.RolePermission>({ url: 'profile/permissions' }), //TODO:: admin hat einen anderen type
	accounts: () =>
		Service.get<Api.Collection<Api.Account>>({ url: 'profile/accounts' }),
	whoami: () => Service.get<Api.WhoAmI>({ url: 'whoami' }),
}

export default userService
